import { REPORT_SUITE_QUESTIONS } from '../config/collectionHomes';
import { ANALYTICS_SUITE_IDS } from '../constants/templates';

// @ts-expect-error Untyped import
import { getHasAccessToTab } from './reportingIAUtils';
// @ts-expect-error Untyped import
import { getHasAccessToSubApp } from './reportingIAUtils';

/**
 * Randomly shuffles an array and returns the first 'count' elements.
 * @param {T[]} array - The array to shuffle.
 * @param {number} count - The number of elements to return.
 * @returns {T[]} The first 'count' elements from the shuffled array.
 */

export function getRandomElements(array, count) {
  const shuffled = array.slice();
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, count);
}

/**
 * Gets the list of analytics suites a user has access to
 * @param {any} analyticsPermissions - The user's gates.
 * @param {any} scopes - The user's scopes.
 * @returns {Question[]} An array of popular questions.
 */

export const getAccessibleSuites = analyticsPermissions => {
  const suiteIds = [ANALYTICS_SUITE_IDS.SALES, ANALYTICS_SUITE_IDS.SERVICE, ANALYTICS_SUITE_IDS.MARKETING];

  // TODO: update once access check functions are cleaned up
  return suiteIds.filter(suiteId => getHasAccessToSubApp(suiteId, analyticsPermissions));
};

/**
 * Gets a list of the popular quick answer questions for a given array of suite ids
 * @param {any} suiteIds - Array of suite ids to get popular questions for.
 * @returns {Question[]} An array of popular quick answer questions.
 */
export function getPopularQuestionsForSuites(suiteIds) {
  return suiteIds.reduce((acc, suiteId) => {
    const suite = REPORT_SUITE_QUESTIONS[suiteId];
    if (suite && suite.popular) {
      acc.push(...suite.popular);
    }
    return acc;
  }, []);
}

/**
 * Filters out questions that map to subsuites or tabs that the user does not have access to
 * @param {Question[]} questions - The list of unfiltered questions.
 * @param {any} gates - The user's gates.
 * @param {any} scopes - The user's scopes.
 * @param {any} analyticsPermissions - The user's analytics permissions.
 * @returns {Question[]} An array of accessible quick answer questions
 */
export function filterOutInaccessibleQuestions(questions, analyticsPermissions, gates, scopes) {
  return questions.filter(({
    subApp,
    contextOverrides
  }) => {
    const tab = contextOverrides === null || contextOverrides === void 0 ? void 0 : contextOverrides.tab;
    return getHasAccessToSubApp(subApp, analyticsPermissions) && (!tab || getHasAccessToTab(subApp, tab, gates, scopes));
  });
}

/**
 * Gets a list of the popular quick answer questions that are accesible to a user
 * @param {any} gates - The user's gates.
 * @param {any} scopes - The user's scopes.
 * @param {any} analyticsPermissions - The user's analytics permissions.
 * @returns {Question[]} An array of popular questions
 */
export function getPopularQuestionsForUser(gates, scopes, analyticsPermissions) {
  const accessibleSuites = getAccessibleSuites(analyticsPermissions);
  const popularQuestions = getPopularQuestionsForSuites(accessibleSuites);
  const filteredQuestions = filterOutInaccessibleQuestions(popularQuestions, analyticsPermissions, gates, scopes);
  return filteredQuestions;
}